import React from 'react';
import ImportarArquivosPage from '../../../components/importacoes/ImportarArquivosPage';

export default function ImportarGuias() {
    return (
        <ImportarArquivosPage
            title="Importação de demonstrações"
            subtitle="Processe as demonstrações contábeis dos clientes de forma automatizada."
            breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Demonstrações contábeis', to: '/demonstracoes-contabeis' }, { label: 'Importar' }]}
            endpoint="demonstracoes/importar"
            formField="demonstracoes"
            uploadTitle="Envie o arquivo compactado das demonstrações"
            uploadDescription="Selecione o arquivo .zip que contém as demonstrações contábeis desejadas."
        />
    );
}
